import { QueryClientHelper } from '#pplx/frontend/react-query/QueryClientHelper.js';
export const COMPUTER_ONBOARDING_CARDS_QUERY_PATH = '/rest/computer/onboarding_cards';
export const COMPUTER_MENU_QUERY_PATH = '/rest/computer/menu';
export const DEFAULT_COMPUTER_MENU_LIMIT = 100;
export const getComputerMenuQueryKey = (limit, collectionUuid, locale, query, sideChatAvailable) => QueryClientHelper.makeQueryKey(COMPUTER_MENU_QUERY_PATH, limit, collectionUuid, locale, query, sideChatAvailable);
// Distinct from `getComputerMenuQueryKey`: the composer caches the flat
// response via `fetchQuery`, while `useComputerMenu` stores `InfiniteData`
// under the legacy key — sharing one key would mix the two shapes. The shared
// path prefix keeps `getComputerMenuQueryKeyPrefix` invalidation covering both.
export const getComposerComputerMenuQueryKey = (limit, collectionUuid, locale) => QueryClientHelper.makeQueryKey(COMPUTER_MENU_QUERY_PATH, 'composer', limit, collectionUuid, locale);
export const getComputerMenuQueryKeyPrefix = () => QueryClientHelper.makeQueryKey(COMPUTER_MENU_QUERY_PATH);
export const getComputerOnboardingCardsQueryKey = () => QueryClientHelper.makeQueryKey(COMPUTER_ONBOARDING_CARDS_QUERY_PATH);
const COMPUTER_ASSET_QUERY_PATH = '/rest/computer/asset';
export const getComputerAssetQueryKey = (slug, view, collectionUuid) => QueryClientHelper.makeQueryKey(COMPUTER_ASSET_QUERY_PATH, slug, view, collectionUuid);
export const getComputerAssetQueryKeyPrefix = () => QueryClientHelper.makeQueryKey(COMPUTER_ASSET_QUERY_PATH);
export const getAssetMembersQueryKey = (assetId) => QueryClientHelper.makeQueryKey('/rest/assets/{asset_id}/members', {
    assetId,
});
export const getPublishedAssetAccessQueryKey = (assetId) => QueryClientHelper.makeQueryKey('/rest/assets/{asset_id}/published-access', {
    assetId,
});
export const getSitePublishInfoQueryKey = (siteId) => QueryClientHelper.makeQueryKey('/rest/assets/sites/{site_id}/publish-info', {
    siteId,
});
const ASSET_SHARE_QUERY_KEY_PREFIX = 'side-canvas-asset-share';
export const getAssetShareQueryKey = (assetIdentifier) => [ASSET_SHARE_QUERY_KEY_PREFIX, assetIdentifier];
//# sourceMappingURL=computerKeys.js.map